<template>
  <v-app light>
      <v-content>
        <v-container>
          <v-layout row>
            <v-flex xs12 md4>
              <div class="text-xs-center">
                <v-avatar size="125px">
                  <img class="img-circle elevation-7 mb-1" src="../../resume/avatar.jpg">
                </v-avatar>
                <div class="headline">{{person.name.first}} <span style="font-weight:bold">{{person.name.last}}</span></div>
                <div class="subheading text-xs-center grey--text pt-1 pb-3">{{person.position}}</div>
                <v-layout justify-space-between>
                  <a :href="'tel:' + person.contact.phone.unformatted"><i class="fa fa-mobile"></i> {{person.contact.phone.formatted}}</a>
                  <div><i class="fa fa-globe"></i> {{person.contact.city}}</div>
                </v-layout>
                <v-layout mt-4 justify-space-between>
                  <a :href="'https://www.twitter.com/' + person.contact.twitter" class="body-2" target="_blank"><i class="fa fa-twitter"></i> Twitter</a>
                  <a :href="'https://www.linkedin.com/in/' + person.contact.linkedin" class="body-2" target="_blank"><i class="fa fa-linkedin"></i> LinkedIn</a>
                  <a :href="'http://github.com/' + person.contact.github" class="body-2" target="_blank"><i class="fa fa-github"></i> Github</a>
                  <a href="http://projectable.me" class="body-2" target="_blank"><i class="fa fa-book"></i> Project Blog</a>
                </v-layout>
                <blockquote class="text-xs-left mt-4">{{person.about}}</blockquote>
                <v-layout row wrap xs12 mt-4 class="text-xs-left">
                  <v-flex xs12>
                    <h5>Notable Skills:</h5>
                  </v-flex>
                  <v-flex xs5 md12 ma-2 mb-0 v-for="skill in person.skills" :key="skill.name">
                    <h6>{{skill.name}}</h6>
                    <v-progress-linear :value="skill.level" height="4" color="success"></v-progress-linear>
                  </v-flex>
                </v-layout>
                <blockquote class="text-xs-left mt-4">{{person.knowledge}}</blockquote>
              </div>
            </v-flex>
            <v-flex xs12 md5 mt-5 offset-md2>
              <h3>Employment History</h3>
              <v-divider></v-divider>
              <v-layout wrap>
                <div v-for="(experience, index) in person.experience" :key="experience.company">
                  <h4 class="blue--text text--darken-1">{{experience.position}}</h4>
                  <h5 v-if="experience.company">{{experience.company}}</h5>
                  <h6 class="green--text text--lighten-1">{{experience.timeperiod}}</h6>
                  <div>{{experience.description}}</div>
                  <v-layout wrap mt-4 v-if="experience.skills">
                    <v-flex xs12>
                      <h5>Skills:</h5>
                    </v-flex>
                    <v-flex v-for="skill in experience.skills" :key="skill.name">
                      <v-chip small>{{skill.name}}</v-chip>
                    </v-flex>
                  </v-layout>
                  <v-divider v-if="index + 1 < person.experience.length"></v-divider>
                </div>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 mt-5>
              <h3>Projects</h3>
              <v-divider></v-divider>
              <blockquote class="text-xs-left mt-3">{{person.projectsummary}}</blockquote>
              <v-flex xs12 offset-md1>
                <v-layout wrap mt-3>
                  <v-flex xs12 md5 ma-3 ml-2 mr-5 v-for="project in person.projects" :key="project.project">
                    <v-card>
                      <v-card-media class="white--text" height="200px" :src="project.image">
                        <v-container fill-height fluid>
                          <v-layout fill-height>
                            <v-flex xs12 align-end flexbox>
                              <span class="headline title-shadow">{{project.name}}</span>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-media>
                      <v-card-title>
                        <div class="green--text text--lighten-1">{{project.completed}}</div>
                        <div class="mt-2">{{project.description}}</div>
                      </v-card-title>
                      <v-btn flat center color="primary" :href="project.url">View Project</v-btn>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
      <v-footer class="secondary" app>
        <v-layout wrap align-center>
          <v-flex xs12>
            <div class="white--text ml-3 text-xs-center">
              &copy; 2023 Daniel Chote
            </div>
          </v-flex>
        </v-layout>
      </v-footer>
    </v-app>
</template>

<script>
import yaml from 'js-yaml'
import {
  PERSON
} from '../../resume/data.yml'

export default {
  name: 'Resume',
  data () {
    return {
      person: yaml.load(PERSON)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.row {
  margin-left: 0px;
  margin-right: 0px;
}
.title-shadow {
  text-shadow: 0px 0px 4px #000;
}
</style>



// WEBPACK FOOTER //
// src/components/Resume.vue